<template>
    <div>
        <vs-popup
                class="deliverer-modal"
                :title="getNameTitle"
                :active.sync="showPopup"
                v-if="coupon !== null"
        >
            <vs-tabs>
                <vs-tab label="Gegevens" :active="true">
                    <template>
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/3 w-full mb-2">
                                <vs-input
                                        class="w-full"
                                        label="Naam"
                                        :value="deliverer.firstname"
                                        v-model="deliverer.firstname"
                                />
                            </div>
                            <div class="vx-col sm:w-1/3 w-full mb-2">
                                <vs-input
                                        class="w-full"
                                        label="Tussenvoegsel"
                                        :value="deliverer.insertion"
                                        v-model="deliverer.insertion"
                                />
                            </div>
                            <div class="vx-col sm:w-1/3 w-full mb-2">
                                <vs-input
                                        class="w-full"
                                        label="Achternaam"
                                        v-if="deliverer.lastname"
                                        :value="deliverer.lastname"
                                        v-model="deliverer.lastname"
                                />
                            </div>
                        </div>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-1/2">
                                <vs-input
                                        class="w-full"
                                        type="email"
                                        label="E-mail"
                                        :value="deliverer.email"
                                        v-model="deliverer.email"
                                />
                            </div>
                            <div class="vx-col w-1/2">
                                <vs-input
                                        class="w-full"
                                        label="Telefoonnummer"
                                        :value="deliverer.phone_number"
                                        v-model="deliverer.phone_number"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col sm:w-1/2 w-full">
                                <vs-input
                                        class="w-full"
                                        type="text"
                                        label="Postcode"
                                        value="3211XM"
                                        v-model="deliverer.postal_code"
                                />
                            </div>
                            <div class="vx-col sm:w-1/2 w-full">
                                <vs-input
                                        class="w-full"
                                        label="Huisnummer"
                                        value="118"
                                        v-model="deliverer.housenumber"
                                />
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-input class="w-full" label="Address" disabled v-model="deliverer.address"/>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-1/2">
                                <vs-select v-model="deliverer.area">
                                    <vs-select-item
                                            v-for="(item) in areaOptions"
                                            :key="item.name"
                                            :value="item.name"
                                            :text="item.name"
                                    />
                                </vs-select>
                            </div>
                            <div class="vx-col w-1/2">
                                <vs-select v-model="deliverer.drivers_licence">
                                    <vs-select-item
                                            v-for="(item) in licenses"
                                            :key="item.name"
                                            :value="item.name"
                                            :text="item.name"
                                    />
                                </vs-select>
                            </div>
                        </div>

                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <ul class="switch-container">
                                    <li>
                                        <label>Kantoor</label>
                                        <vs-switch v-model="deliverer.office"/>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <vs-card>
                            <div slot="header">
                                <h5>Afbeelding</h5>
                            </div>
                            <div style="margin: 0 auto">
                                <vs-upload @change="handleImageUpload" @on-delete="image = null"/>
                            </div>
                        </vs-card>


                        <div class="vx-row">
                            <div class="vx-col w-full">
                                <vs-button
                                        class="mr-3 mb-2"
                                        @click="saveDelivererModal(deliverer)"
                                        style="text-align: right"
                                >Opslaan
                                </vs-button>
                                <vs-button
                                        class="mr-3 mb-2"
                                        @click="resetDeviceToken(deliverer)"
                                        style="text-align: right"
                                >Reset device token
                                </vs-button>
                            </div>
                        </div>
                    </template>
                </vs-tab>
                <vs-tab label="Notities">
                    <vs-list>
                        <vs-list-item v-for="note in notes" :title="note.note" subtitle></vs-list-item>
                        <vs-list-item v-if="notes === null" title="Notities laden..." subtitle></vs-list-item>
                        <div v-if="notes !== null">
                            <vs-list-item v-if="notes.length === 0" title="Geen notities gevonden"
                                          subtitle></vs-list-item>
                        </div>
                    </vs-list>
                </vs-tab>
                <vs-tab label="Uren">
                    <vs-collapse>
                        <vs-collapse-item v-for="(item, index) in hours">
                            <div slot="header">{{ getMonth(index) }}</div>
                            <vs-list>
                                <vs-list-item
                                        v-for="hour in item"
                                        class="va-list-item"
                                        :title="$moment(hour.clocked_in_time).calendar()"
                                        :subtitle="getTranslatedString(hour)"
                                >
                                    <vs-button
                                            color="danger"
                                            type="flat"
                                            icon-pack="feather"
                                            icon="icon-trash-2 "
                                            @click="deleteHour(hour)"
                                    ></vs-button>
                                </vs-list-item>
                            </vs-list>
                        </vs-collapse-item>
                    </vs-collapse>
                </vs-tab>
            </vs-tabs>
        </vs-popup>
        <vs-popup
                class="deliverer-modal"
                title="Coupon aanmaken"
                :active.sync="showCreatePopup"
        >
            <template>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Code"
                                :value="createCoupon.code"
                                v-model="createCoupon.code"
                        />
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full mb-2">
                        <label for="datepicker" class="vs-input--label">Startdatum</label>
                        <datepicker
                                placeholder="Selecteer een datum"
                                label="Startdatum"
                                v-model="createCoupon.start_date"
                        ></datepicker>
                    </div>
                    <div class="vx-col w-full mb-2">
                        <label for="datepicker" class="vs-input--label">Einddatum</label>
                        <datepicker
                                placeholder="Selecteer een datum"
                                label="Startdatum"
                                v-model="createCoupon.end_date"
                        ></datepicker>
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Bedrag"
                                :value="createCoupon.amount"
                                v-model="createCoupon.amount"
                        />
                    </div>
                    <div class="vx-col sm:w-1/3 w-full mb-2">
                        <vs-input
                                class="w-full"
                                label="Percentage"
                                :value="createCoupon.percentage"
                                v-model="createCoupon.percentage"
                        />
                    </div>
                </div>
                <div class="vx-row">
                    <div class="vx-col w-full">
                        <vs-button class="mr-3 mb-2" @click="saveCoupon(createCoupon)">Opslaan</vs-button>
                    </div>
                </div>

            </template>
        </vs-popup>
    </div>
</template>

<script>
    import Datepicker from "vuejs-datepicker";

    export default {
        name: "ht-coupon-popup",
        components: {
            Datepicker,
        },
        data() {
            return {
                coupon: null,
                showPopup: false,
                showCreatePopup: false,
                createCoupon: {
                    code: 'JdnwoA',
                    start_date: '',
                    end_date: '',
                    amount: 0,
                    percentage: 0
                }
            };
        },
        mounted() {
            this.$events.listen('open-coupon-modal', (coupon) => {
                this.coupon = coupon;
                this.showPopup = true;
            });
            this.$events.listen('create-coupon-modal', () => {
                this.showCreatePopup = true;
            });
            window.addEventListener('keyup', (key) => {
                if (key.keyCode === 27) {
                    this.showCreatePopup = false;
                    this.showPopup = false;
                }
            });
        },

        computed: {
            getNameTitle: function () {
                if (this.coupon === null) {
                    return 'Coupon aanmaken';
                }
                return this.coupon.code;
            },
        },

        watch: {},

        methods: {
            handleImageUpload: function (e, f) {
                this.image = f[0];
            },
            getTranslatedString(item) {
                return (
                    "Ingeklokt om " +
                    this.$moment(item.clocked_in_time).format("LTS") +
                    " uitgeklokt om " +
                    this.$moment(item.clocked_out_time).format("LTS")
                );
            },
            saveCoupon(coupon) {
                let formData = new FormData();

                formData.append('code', coupon.code);
                formData.append('start_date', coupon.start_date);
                formData.append('end_date', coupon.end_date);
                formData.append('amount', coupon.amount);
                formData.append('percentage', coupon.percentage);

                this.$http.post('/v1/company/' + this.$route.params.slug + '/coupon/create', formData,
                    {
                        headers: {
                            Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('stafftoken')),
                            'Content-Type': 'multipart/form-data'
                        }
                    }).then((response) => {
                    this.$vs.notify({
                        title: 'Success',
                        text: 'Kortingscode aangemaakt',
                        color: 'success'
                    });
                    this.refreshCoupons();
                }).catch((error) => {
                    this.$util.logError(error, this.$vs);
                });
            },
            deleteCoupon(coupon) {
                let data = {
                    code: coupon.code,
                };
                this.$http
                    .post("https://staffapi.hebtrek.nl/v1/company/" + this.$route.params.slug + "/coupon/delete", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then((response) => {
                        this.refreshCoupons();
                        this.$vs.notify({
                            title: "Gelukt!",
                            text: "Coupon is verwijderd",
                            color: "green",
                            position: "top-center",
                        });
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            resetDeviceToken(deliverer) {
                let data = {
                    id: this.deliverer.id,
                };
                this.$http
                    .post(
                        "https://staffapi.hebtrek.nl/v1/deliverer/reset-device-token",
                        data,
                        {
                            headers: {
                                Authorization:
                                    "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                            },
                        }
                    )
                    .then((response) => {
                        this.showPopup = false;
                        this.$vs.notify({
                            title: "Gelukt!",
                            text: "Token van " + deliverer.firstname + " gereset!",
                            color: "green",
                            position: "top-center",
                        });
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            refreshCoupons() {
                this.$events.fire('refresh-coupons');
                this.showPopup = false;
                this.showCreatePopup = false;
            },
            createDelivererModel(deliverer) {
                let data = {
                    _method: "POST",
                    office: deliverer.office,
                    area: deliverer.area,
                    firstname: deliverer.firstname,
                    insertion: deliverer.insertion,
                    lastname: deliverer.lastname,
                    birth_date: deliverer.birth_date,
                    address: deliverer.address,
                    phone_number: deliverer.phone_number,
                    email: deliverer.email,
                    drivers_licence: deliverer.drivers_licence,
                    salary: deliverer.salary,
                };
                this.$http
                    .post("https://staffapi.hebtrek.nl/v1/deliverer/create", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then((response) => {
                        this.showCreatePopup = false;
                        this.$events.fire("update-deliverer-list");
                        this.$vs.notify({
                            title: "Gelukt!",
                            text: "Bezorger " + deliverer.firstname + " is aangemaakt",
                            color: "green",
                            position: "top-center",
                        });
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            fireDeliverer(deliverer) {
                let data = {
                    _method: "DELETE",
                    id: deliverer.id,
                    reason: "Ontslagen op staande voet",
                };
                this.$http
                    .post("https://staffapi.hebtrek.nl/v1/deliverer/fire", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then((response) => {
                        this.showPopup = false;
                        this.$util.logError(error, this.$vs);
                    })
                    .catch((error) => {
                    });
            },

            getNotes: function () {
                this.notes = null;
                this.$http
                    .get("https://staffapi.hebtrek.nl/v1/deliverer/notes", {
                        params: {
                            id: this.deliverer.id,
                        },
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then((response) => {
                        this.notes = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },

            getHours() {
                this.hours = null;
                this.$http
                    .get("https://staffapi.hebtrek.nl/v1/deliverer/hours", {
                        params: {
                            id: this.deliverer.id,
                        },
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then((response) => {
                        this.hours = response.data;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },

            getAddress: function () {
                if (this.deliverer === null) {
                    return;
                }
                if (this.deliverer.housenumber === "") {
                    return;
                }
                this.$http
                    .get(
                        "https://staffapi.hebtrek.nl/v1/address?api_token=" +
                        JSON.parse(localStorage.getItem("stafftoken")),
                        {
                            params: {
                                zipcode: this.deliverer.postal_code,
                                number: this.deliverer.housenumber,
                            },
                        }
                    )
                    .then((response) => {
                        this.deliverer.address =
                            response.data.street +
                            " " +
                            response.data.number +
                            ", " +
                            response.data.postcode +
                            ", " +
                            response.data.city;
                        this.deliverer.street = response.data.street;
                        this.deliverer.city = response.data.city;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
            clockOut(deliverer) {
                this.showPopup = false;
                this.$vs.notify({
                    title: "Wat een strijder",
                    text: "Je hebt " + deliverer.firstname + " uitgeklokt",
                    color: "red",
                    position: "top-center",
                });
            },
            saveDelivererModal(deliverer) {
                let data = {
                    _method: "PUT",
                    id: deliverer.id,
                    office: deliverer.office,
                    area: deliverer.area,
                    firstname: deliverer.firstname,
                    insertion: deliverer.insertion,
                    lastname: deliverer.lastname,
                    postal_code: deliverer.postal_code,
                    housenumber: deliverer.housenumber,
                    city: deliverer.city,
                    street: deliverer.street,
                    birth_date: deliverer.birth_date,
                    address: deliverer.address,
                    phone_number: deliverer.phone_number,
                    email: deliverer.email,
                    drivers_licence: deliverer.drivers_licence,
                    image: this.image,
                    device_token: this.device_token,
                };
                this.$http
                    .post("https://staffapi.hebtrek.nl/v1/deliverer/update", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                        },
                    })
                    .then((response) => {
                        this.saved = true;
                        this.showPopup = false;
                        this.$vs.notify({
                            title: "Gelukt!",
                            text: "Gegevens voor " + deliverer.firstname + " zijn opgeslagen!",
                            color: "green",
                            position: "top-center",
                        });
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            },
        },
    };
</script>

<style>
    .vs-list {
        padding: 0;
    }

    .va-list-item {
        padding: 0;
        margin-left: -10px;
        margin-right: -10px;
    }

    .ht-image {
        width: auto;
    }

    .img-upload,
    .con-input-upload {
        width: 100%;
        margin-left: 0px;
        margin-top: 0px;
    }
</style>

